const Color = [
  {
    bgPanel: "var(--tab-pn-all)",
    bgTab: "var(--tab-all)",
  },
  {
    bgPanel: "var(--tab-pn-recommendation)",
    bgTab: "var(--tab-recommendation)",
  },
  {
    bgPanel: "var(--tab-pn-high-reward)",
    bgTab: "var(--tab-high-reward)",
  },
  {
    bgPanel: "var(--tab-pn-popular)",
    bgTab: "var(--tab-popular)",
  },
  {
    bgPanel: "var(--tab-pn-esthetic)",
    bgTab: "var(--tab-esthetic)",
  },
  {
    bgPanel: "var(--tab-pn-product)",
    bgTab: "var(--tab-product)",
  },
  {
    bgPanel: "var(--tab-pn-card)",
    bgTab: "var(--tab-card)",
  },
  {
    bgPanel: "var(--tab-pn-insurance)",
    bgTab: "var(--tab-insurance)",
  },
  {
    bgPanel: "var(--tab-pn-others)",
    bgTab: "var(--tab-others)",
  },
  {
    bgPanel: "var(--tab-pn-others)",
    bgTab: "var(--tab-others)",
  },
  {
    bgPanel: "var(--tab-pn-others)",
    bgTab: "var(--tab-others)",
  },
];

export { Color };
